const globalWindow = (window as any);

export const googleApiKey = "AIzaSyARMAWiwgcXBZaACKO57HF_r9bAO0zhh58";

export const loadGoogle = () : Promise<google.maps.places.PlacesService> => {
  return new Promise<google.maps.places.PlacesService>(resolve =>{
    if(!globalWindow.acmaGooglePlaces) {
      const scriptId = "acmaGoogleMaps";
      const scriptExisting = document.getElementById(scriptId);

      globalWindow.acmaGoogleCallbackFns = (globalWindow.acmaGoogleCallbackFns ?? []).concat(resolve);

      if(!scriptExisting) {
        globalWindow.acmaGoogleCallback = function () {
          globalWindow.acmaGooglePlaces = new google.maps.places.PlacesService(document.createElement("div"));

          for (let fn of globalWindow.acmaGoogleCallbackFns) {
            fn(globalWindow.acmaGooglePlaces);
          }
          globalWindow.googleCallbackFns = [];  
        };   

        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${googleApiKey}&libraries=places&callback=acmaGoogleCallback`;
        script.id = scriptId;
        document.body.appendChild(script);     
      }
    }
    else {
      resolve(globalWindow.acmaGooglePlaces);
    }
  });
};

loadGoogle();